<template lang="pug">
  div
    .placeholder(v-if='loading')
    .content.year(v-if='!loading')
      .grid
        .col-3.titles
          router-link(:to={path: '/exhibitions'})
            h1.h-l
              | exhibitions
          h4.status
            | {{ $route.params.year }}
        .col-9_xs-12
          .grid.no-margin
            .col-6_xs-12(v-for="exhibition in exhibitions")
              router-link(:to="{path: exhibition.content.year + '/' + exhibition.uid}")
                .screen-small
                  img.cover(:src="exhibition.image" :alt="exhibition.content.title")
                  .captions
                    h2.title.h-l.italic
                      | {{ exhibition.content.title }}
                    h2.dates.h-sm
                      | {{ displayDate(exhibition) }}
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'
import dateFormat from 'dateformat'

export default {
  name: 'exhibitions-upcoming',
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      loading: false,
      loadedData: [],
      // url: 'http://localhost:8888/caam/caam_live/api/exhibitions-upcoming/'
      url: 'https://staging.caamuseum.org/api/exhibitions-upcoming/'
    }
  },

  created () {
    this.key = 'upcoming'
    this.getData()
  },

  methods: {
    getData: function () {
      this.loading = true
      this.get(this.url, response => {
        this.loading = false
        this.loadedData = response.data
      })
    },

    hero: function (image, files) {
      return files.find(item => item.filename === image)
    },

    startDate: function (date) {
      if (date) {
        const d = new Date(date)
        return dateFormat(d, 'mmmm d')
      } else {
        return ''
      }
    },

    endDate: function (date) {
      if (date) {
        const d = new Date(date)
        return dateFormat(d, 'mmmm d, yyyy')
      } else {
        return ''
      }
    },

    /* eslint-disable */
    displayDate: function (exhibition) {
      const dd = exhibition.content.display_date
      console.log(dd)
      const date = exhibition.content.start_date + ' - ' + exhibition.content.end_date
      return !!dd ? dd : date
    },
    /* eslint-enable */

    year: function (date) {
      if (date) {
        const d = new Date(date)
        return dateFormat(d, 'yyyy')
      } else {
        return ''
      }
    }
  },

  computed: {
    exhibitions: function () {
      return this.loadedData[this.key]
    },

    parameter: function () {
      return this.$route.params.year
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_variables.sass'
  @import '../styles/_mixins'
  .content
    margin-top: $paddingTop
    @include respond-to(xs)
      margin-top: 1rem
    &.year
      .titles
        h2, h4
          padding-left: 0
      .status
        color: $exhibitions
        font-size: 2rem
</style>



// WEBPACK FOOTER //
// ExhibitionsUpcoming.vue?1cb8273d